import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { SettingsService } from 'lib-shared';
import { lastValueFrom } from 'rxjs';
import { PersistenceService } from '../persistence/persistence.service';
import { MY_ACCOUNT_CONFIG } from '../../config/my-account.config';
import { ApiResponse, LocalStorageList, OldApiResponse } from '../../../public-api';

@Injectable({
  providedIn: 'root',
})
export class PreSuspendedService {
  private config = inject(MY_ACCOUNT_CONFIG);
  persistenceService = inject(PersistenceService);

  constructor(private http: HttpClient, private settings: SettingsService) {}

  async getPreSuspendedData<T>() {
    const suspendedData = this.persistenceService.getData(LocalStorageList.suspended, true);

    const headers = new HttpHeaders().set('authorization', `Bearer ${suspendedData.token}`);

    const res = this.http.get<ApiResponse<T>>(
      `${this.settings.getHubBaseUrlApi}/${this.config.controllerApiList.HubApi.VnumberApi.PreSuspended}`, { 'headers': headers }
    );
    const data = await lastValueFrom(res);

    return data;
  }

  async submitSuspendedPayment<T>(data: any) {
    const suspendedData = this.persistenceService.getData(LocalStorageList.suspended, true);

    const headers = new HttpHeaders().set('token', `${suspendedData.token}`);

    const res = this.http.post<OldApiResponse<T>>(
      `${this.settings.getBaseUrlApi}/${this.config.controllerApiList.WebApi.SubmitPreSuspended}`, data, { 'headers': headers }
    );
    const dataResponse = await lastValueFrom(res);

    return dataResponse;
  }
}
